module.exports = __webpack_public_path__ + "media/components/lesson1/statics/iconImage-5463c5110b655a2b697f51934b2f5a4d.png";